import { AlertTriangle } from "lucide-react";

export const DISCLAIMER_TEXT = (
  <>
    <b>Important Legal Disclaimer:</b> TheMindStein strictly prohibits any use
    related to arms, weapons, military equipment, aerospace systems, or
    activities violating US export controls (ITAR) or Canadian laws. We
    maintain technical blocks to prevent such misuse. Users attempting
    violations will be permanently banned and held accountable. We will fully
    cooperate with law enforcement in any jurisdiction.
  </>
);

/**
 * RedDisclaimer — reusable, high-contrast red block for the exact wording
 * required by legal / Stripe compliance. Renders identically on landing,
 * signup, and the bot.
 */
export default function RedDisclaimer({
  compact = false,
  showBotNote = false,
  testid = "red-disclaimer",
}) {
  return (
    <div
      data-testid={testid}
      role="alert"
      className={`border-2 border-red-500 bg-red-950/40 text-red-100 ${
        compact ? "p-2" : "p-4"
      }`}
    >
      <div className="flex items-start gap-2">
        <AlertTriangle
          size={compact ? 14 : 18}
          className="text-red-400 mt-0.5 shrink-0"
        />
        <div className="min-w-0">
          <p className={`${compact ? "text-[11px]" : "text-[12px]"} leading-relaxed font-mono`}>
            {DISCLAIMER_TEXT}
          </p>
          {showBotNote && (
            <p className="mt-2 text-[11px] font-mono text-red-200/90 leading-relaxed">
              <b>Note:</b> We have technical blocks in place. Breaking these
              laws leads to bans and full cooperation with authorities.
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
